import React from 'react';
import Icon from '../../../components/AppIcon';

const TravelStats = ({ stats }) => {
  const statCards = [
    {
      title: 'Active Travel Requests',
      value: stats?.activeTravelRequests || 0,
      change: '+5',
      changeType: 'increase',
      icon: 'Plane',
      color: 'primary'
    },
    {
      title: 'Upcoming Trips',
      value: stats?.upcomingTrips || 0,
      change: '+3',
      changeType: 'increase',
      icon: 'Calendar',
      color: 'secondary'
    },
    {
      title: 'Budget Utilization',
      value: `${stats?.budgetUtilization || 0}%`,
      change: '+8%',
      changeType: 'increase',
      icon: 'DollarSign',
      color: 'accent'
    },
    {
      title: 'Compliance Issues',
      value: stats?.complianceIssues || 0,
      change: '-2',
      changeType: 'decrease',
      icon: 'AlertTriangle',
      color: 'warning'
    },
    {
      title: 'Pending Approvals',
      value: stats?.pendingApprovals || 0,
      change: '+1',
      changeType: 'increase',
      icon: 'Clock',
      color: 'error'
    },
    {
      title: 'Active Bookings',
      value: stats?.activeBookings || 0,
      change: '+12',
      changeType: 'increase',
      icon: 'CheckCircle',
      color: 'success'
    }
  ];

  const getColorClasses = (color) => {
    switch (color) {
      case 'primary': return 'text-primary bg-primary/10 border-primary/20';
      case 'success': return 'text-success bg-success/10 border-success/20';
      case 'warning': return 'text-warning bg-warning/10 border-warning/20';
      case 'error': return 'text-error bg-error/10 border-error/20';
      case 'secondary': return 'text-secondary bg-secondary/10 border-secondary/20';
      case 'accent': return 'text-accent bg-accent/10 border-accent/20';
      default: return 'text-muted-foreground bg-muted/10 border-muted/20';
    }
  };

  const getChangeColor = (changeType) => {
    switch (changeType) {
      case 'increase': return 'text-success';
      case 'decrease': return 'text-error';
      default: return 'text-muted-foreground';
    }
  };

  const getChangeIcon = (changeType) => {
    switch (changeType) {
      case 'increase': return 'TrendingUp';
      case 'decrease': return 'TrendingDown';
      default: return 'Minus';
    }
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-6 mb-8">
      {statCards?.map((stat, index) => (
        <div
          key={index}
          className="glass-container rounded-xl border border-border/50 p-6 hover:shadow-glass-lg transition-all duration-200"
        >
          <div className="flex items-center justify-between mb-4">
            <div className={`w-12 h-12 rounded-lg flex items-center justify-center border ${getColorClasses(stat?.color)}`}>
              <Icon name={stat?.icon} size={24} />
            </div>
            <div className="flex items-center space-x-1">
              <Icon 
                name={getChangeIcon(stat?.changeType)} 
                size={16} 
                className={getChangeColor(stat?.changeType)}
              />
              <span className={`text-sm font-medium ${getChangeColor(stat?.changeType)}`}>
                {stat?.change}
              </span>
            </div>
          </div>
          
          <div>
            <h3 className="text-2xl font-bold text-foreground mb-1">
              {typeof stat?.value === 'number' ? stat?.value?.toLocaleString() : stat?.value}
            </h3>
            <p className="text-sm text-muted-foreground">{stat?.title}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default TravelStats;